module.exports = __webpack_public_path__ + "static/media/logo.ace25ff7.svg";